import { Col, Table } from "reactstrap";

const SkorHeader = ({ className, predikat }) => {
  return (
    <Col className={className}>
      <Table bordered>
        <thead>
          <tr>
            <th>Predikat</th>
            <th>Skor</th>
            <th className="px-3">Rentang</th>
          </tr>
        </thead>
        <tbody>
          {predikat.map((item, index) => (
            <tr key={index}>
              <th>{item.predikat}</th>
              <td>{item.skor}</td>
              <td>{item.rentang_skor}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Col>
  );
};

export default SkorHeader;
